import { Box } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import CommonDrawer from "../../drawer/CommonDrawer";
import Text from "../../text/Text";
import { QRCodeComponent } from "../../qrCode/QRCodeComponent";
import {
  appDownloadHint,
  downloadApp,
  navigationForAppDownload,
} from "../../messages";
import { mobileAppUrl } from "../../constants";
import { appStoreBadge, googlePlayBadge } from "../../images";

const renderBody = () => (
  <Box p="0 12px">
    <Box mb="26px">
      <Text size={16} font="regular">
        {appDownloadHint}
      </Text>
      <Text size={16} font="regular">
        {navigationForAppDownload}
      </Text>
    </Box>
    <QRCodeComponent
      value={mobileAppUrl}
      size={290}
      icon
      iconSize={24}
      level={"H"}
    />
    <Box mt="26px" display="flex" justifyContent="center">
      <img
        src={googlePlayBadge}
        style={{ marginRight: "10px" }}
        alt="google-play-badge"
      />
      <img src={appStoreBadge} alt="app-store-badge" />
    </Box>
  </Box>
);

const UpgradePlanDrawer = ({ openModal, setOpenModal }) => {
  return (
    <CommonDrawer
      anchor="bottom"
      open={openModal}
      onClose={() => setOpenModal(false)}
      className="upgrade-limit-drawer"
    >
      <Box className="drawer-header">
        <ArrowBackIcon
          onClick={() => {
            setOpenModal(false);
          }}
        ></ArrowBackIcon>
        {downloadApp}
      </Box>
      <Box className="drawer-content">{renderBody()}</Box>
    </CommonDrawer>
  );
};

export default UpgradePlanDrawer;
